export default __webpack_public_path__ + "static/media/d-2.0e73961d.png";